export const getUniqueFileTypes = (product, selectedOptions) => {
  // Todo: remove this once we have setup the correct options mode for the all categories.
  if (!["Women's Clothing", "Men's Clothing"].includes(product.category) ) {
    return product.files;
  }

  const fileMap = new Map();

  if (Array.isArray(product.options)) {
    product.options.forEach(option => {
      const selectedValue = selectedOptions[option.type];
      if (
        selectedValue &&
        option.option_reference === selectedValue &&
        Array.isArray(option.files)
      ) {
        option.files.forEach(file => {
          if (file && !fileMap.has(file.type)) {
            fileMap.set(file.type, file);
          }
        });
      }
    });
  }

  return Array.from(fileMap.values());
}

export const getFileTypesForCartItem = (cartItem) => {
  if (cartItem.required_files && cartItem.required_files.length) {
    return cartItem.required_files
  }

  return cartItem.cpProductInfo.files
}
